import React from "react";
import {
  ProductTabWraper,
  HtmlWrapper,
  CertificationContainer,
  CertificationHeader,
  CertificationGrid,
  CertificationItem,
  MoreButton,
} from "./ProductDetails-styles";
import { useRouter } from "next/router";
import Link from "next/link";

const ProductTab = ({ product }) => {
  const router = useRouter();

  const activeCertifications = [
    product?.ecoLabelYn === "Y",
    product?.fscYn === "Y",
    product?.sfnzYn === "Y",
  ].filter(Boolean).length;

  const renderCertifications = activeCertifications > 0;
  return (
    <ProductTabWraper>
      {renderCertifications && (
        <CertificationContainer>
          <CertificationHeader>
            <h3>상품 인증현황</h3>
            <p>안심하고 사용수 있도록 이 상품이 획득한 공식 인증입니다.</p>
          </CertificationHeader>

          <CertificationGrid itemCount={activeCertifications}>
            {product?.ecoLabelYn === "Y" && (
              <CertificationItem>
                <div className="icon-container">
                  <img
                    src="https://file.caretbio.com/caretbio/40e8d6467e3b100b231f32c1c0232f77.png"
                    alt="환경표지인증 확특"
                  />
                </div>
                <div className="cert-name">환경표지인증 획득</div>
                <div className="cert-description">국가공인 인증권 인증</div>
              </CertificationItem>
            )}

            {product?.fscYn === "Y" && (
              <CertificationItem>
                <div className="icon-container">
                  <img
                    src="https://file.caretbio.com/caretbio/90a455c40faad55e4482ac7e665fd033.png"
                    alt="FSC 인증 획득"
                  />
                </div>
                <div className="cert-name">FSC 인증 획득</div>
                <div className="cert-description">글로벌 친산림 인증</div>
              </CertificationItem>
            )}

            {product?.sfnzYn === "Y" && (
              <CertificationItem>
                <div className="icon-container">
                  <img
                    src="https://file.caretbio.com/caretbio/852a28511e681460de2cf90fa473434a.png"
                    alt="스텝포넷제로 인증 획득"
                  />
                </div>
                <div className="cert-name">스텝포넷제로 인증 획득</div>
                <div className="cert-description">탄소저감 인증</div>
              </CertificationItem>
            )}
          </CertificationGrid>

          <MoreButton onClick={() => router.push("/esg-guide/certification/")}>
            <button>
              더 알아보기
              <p>
                <i className="fi-rs-angle-right" />
              </p>
            </button>
          </MoreButton>
        </CertificationContainer>
      )}

      <div className="d-flex justify-content-center">
        <HtmlWrapper>
          {product?.smallYn === "Y" && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "12px 0 8px",
                width: "100%",
              }}
            >
              <Link href="/customizing/print/">
                <a
                  aria-label="소량인쇄 서비스 바로가기"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: "inline-block", maxWidth: 860, width: "100%", cursor: "pointer" }}
                >
                  <img
                    src="/img/common/small_info.png"
                    alt="소량인쇄_서비스소개"
                    style={{ maxWidth: 860, width: "100%", height: "auto", display: "block", margin: 0 }}
                    draggable={false}
                  />
                </a>
              </Link>
            </div>
          )}
          <div
            className="ck-content"
            dangerouslySetInnerHTML={{ __html: product?.content }}
          />
        </HtmlWrapper>
      </div>
    </ProductTabWraper>
  );
};

export default ProductTab;
